// import node module libraries
import { Fragment } from 'react';

// import sub components
import ContactSupportSection from './ContactSupportSection';
import HeroGradientHeader from './HeroGradientHeader';
import HelpCenterFAQs from './HelpCenterFAQs';

import SEO from 'components/marketing/seo/Seo';

const HelpCenter = () => {
	return (
		<Fragment>
			<SEO
				title="Help Center & Support"
				description="Finde Antworten zu Funktionen, Integrationen & Preisen. Lies Anleitungen oder sende ein Support-Ticket. Schnelle Hilfe rund um die Multi‑Channel Plattform."
				keywords="saas hilfecenter, multi channel support, software faq"
				canonical="https://haeppy.app/marketing/help-center"
			/>
			{/* hero gradient header with features */}
			<HeroGradientHeader />

			{/* FAQs section  */}
			<HelpCenterFAQs />

			{/* contact / support section */}
			<ContactSupportSection />

		</Fragment>
	);
};
export default HelpCenter;
